/* Print Phuket product page (14 Oct 2026).
   Enhances the theme's native product form; Shopify variants stay the single source of truth for price and checkout.
   - Live state from /products/<handle>?view=pp (works above 250 variants, unlike /products/<handle>.js)
   - No ฿0 sales: unpriced variants show "Price on request" + quote link, and add-to-cart requests for them are blocked
   - Quantity tiers: total, price per piece and real savings vs the smallest pack (only from real prices)
   - Option explanations, size & shape guide, gallery caption for option photos (and an honest fallback)
   - Artwork step (OPTIS + Uploadly + link) shown as clear choices; sticky mobile purchase bar; share dialog
   - Frequently bought together: each extra item has its own options and its own artwork answer (_pp_own)
   - Analytics: dataLayer + Shopify.analytics custom events (no third-party scripts) */
(function () {
  'use strict';
  var root = document.querySelector('product-info.pp-pdp');
  if (!root || root.__pp) return; root.__pp = true;
  var SID = root.getAttribute('data-section');
  var CFG = window.ppPdpConfig || {};
  var dataEl = document.getElementById('pp-data-' + SID);
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var FORM_ID = 'product-form-' + SID;
  var SEP = ' · ';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var priceById = {};                       // variant id -> price (satang) for every variant we have seen
  var cache = {};                           // view url -> data

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) {
    var f = CFG.moneyFormat || '{{amount}} ฿';
    var n = (c || 0) / 100;
    var two = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var none = Math.round(n).toLocaleString('en-US');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.')).replace(/\{\{\s*amount\s*\}\}/, two).replace(/<[^>]*>/g, '');
  }
  function moneyShort(c) { // per-piece prices keep 2 decimals, whole totals drop .00
    var s = money(c); return (c % 100 === 0) ? s.replace(/\.00(?=\D|$)/, '') : s;
  }
  function track(ev, d) {
    d = d || {}; d.event = ev; d.product = D.handle;
    try { (window.dataLayer = window.dataLayer || []).push(d); } catch (e) {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(ev, d); } catch (e) {}
  }
  function qa() {
    try {
      var role = window.Shopify && Shopify.theme && Shopify.theme.role;
      if (role && role !== 'main' && /[?&]pp_qa=1/.test(location.search)) sessionStorage.setItem('pp_qa', '1');
      return !!(role && role !== 'main' && sessionStorage.getItem('pp_qa') === '1');
    } catch (e) { return false; }
  }
  var QA = qa();
  var QUOTE_ONLY = (D.tags || []).indexOf('quote-only') > -1;
  function num(label) { var m = String(label).replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : 0; }
  function unitWord(label) {
    var w = String(label).replace(/[\d,.\s]+/, '').trim().toLowerCase();
    if (!w || w === 'pcs' || w === 'pc') return 'piece';
    return w.replace(/ies$/, 'y').replace(/(s)$/, '');
  }
  function rememberPrices(d) {
    if (!d) return;
    if (d.variant) priceById[d.variant.id] = d.variant.price;
    var last = d.options[d.options.length - 1];
    if (last) last.values.forEach(function (v) { if (v.vid) priceById[v.vid] = v.price; });
  }
  function view(url, params) {
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=pp' + (params ? '&' + params : '');
    if (cache[u]) return Promise.resolve(cache[u]);
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { cache[u] = d; rememberPrices(d); return d; });
  }
  rememberPrices(D);

  function compNames(d) {
    var o = d.options[0]; var c = d.compound && o && d.compound[o.name];
    return Array.isArray(c) ? c : null;
  }
  function selectionParts(d) { // [{name, value}] for every component + quantity
    var out = [], names = compNames(d);
    d.options.forEach(function (o, i) {
      if (i === 0 && names) {
        var parts = String(o.selected).split(SEP);
        names.forEach(function (n, k) { out.push({ name: n, value: parts[k] || '' }); });
      } else out.push({ name: o.name, value: o.selected });
    });
    return out;
  }
  function qtyOption(d) { var o = d.options[d.options.length - 1]; return (o && /quantity|qty|pack/i.test(o.name) && d.options.length > 1) ? o : null; }
  function isPending(d) { return !d.variant || !(d.variant.price > 0); }
  function optsText(d) { var o = d.options[0]; return d.options.length > 1 ? o.selected : d.variant.title; }

  /* ---------- live state ---------- */
  var current = D;
  var lastVid = D.variant.id;
  function currentVid() { var i = document.querySelector('#' + FORM_ID + ' [name="id"]'); return i ? +i.value : D.variant.id; }
  function refresh(how) {
    var vid = currentVid();
    if (!vid) return;
    if (vid === lastVid && how !== 'force') return;
    lastVid = vid;
    view(D.url, 'variant=' + vid).then(function (d) { if (d.variant.id !== currentVid()) return; current = d; render(); })
      .catch(function () { /* keep the last good state */ });
  }
  root.addEventListener('variant:changed', function () { refresh(); });
  document.addEventListener('variant:changed', function () { refresh(); });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(refresh, 400); });
  setInterval(function () { if (currentVid() !== lastVid) refresh(); }, 800); // safety net if the theme changes the id silently

  /* ---------- price block ---------- */
  function paintPrice() {
    var d = current, pending = isPending(d);
    root.classList.toggle('pp-is-pending', pending);
    document.documentElement.classList.toggle('pp-pending-page', pending);
    var pr = document.getElementById('price-' + SID);
    if (pr) {
      var box = pr.querySelector('.pp-pricebox');
      if (!box) { box = document.createElement('div'); box.className = 'pp-pricebox'; pr.appendChild(box); }
      if (pending) {
        box.innerHTML = '<span class="pp-pricebox__req">Price on request</span><span class="pp-pricebox__sub">for this selection</span>';
      } else {
        var q = qtyOption(d), n = q ? num(q.selected) : 0, html = '';
        if (n > 1) html += '<span class="pp-pricebox__unit">' + moneyShort(Math.round(d.variant.price / n)) + ' per ' + esc(unitWord(q.selected)) + '</span>';
        if (q) html += '<span class="pp-pricebox__sub">for ' + esc(q.selected) + '</span>';
        box.innerHTML = html;
      }
    }
    // pending panel + quote links
    var qb = $('[data-pp-buy]', root);
    var base = qb ? qb.getAttribute('data-quote-base') : '/pages/get-a-quote?from=' + encodeURIComponent(location.pathname);
    var q2 = qtyOption(d);
    var href = base + '&opts=' + encodeURIComponent(optsText(d)) + (q2 ? '&qty=' + encodeURIComponent(q2.selected) : '');
    $$('[data-pp-quote]').forEach(function (a) { a.setAttribute('href', href); });
    var cq = $('[data-pp-quote-custom]', root); if (cq) cq.setAttribute('href', href);
    var pen = $('[data-pp-pending]', root); if (pen) pen.hidden = !pending;
  }

  /* ---------- quantity tiers ---------- */
  function paintTiers() {
    var d = current, q = qtyOption(d);
    var native = q ? document.getElementById('pp-native-' + SID + '-' + q.position) : null;
    if (!q || !native) return;
    var host = document.getElementById('pp-tiers-' + SID);
    if (!host) {
      host = document.createElement('div'); host.id = 'pp-tiers-' + SID; host.className = 'pp-tiers';
      native.parentNode.insertBefore(host, native.nextSibling);
      native.classList.add('pp-native-hidden');
      root.classList.add('pp-has-tiers');
      native.setAttribute('aria-hidden', 'true');
      $$('input', native).forEach(function (i) { i.tabIndex = -1; });
    }
    var vals = q.values, base = null;
    vals.forEach(function (v) { var n = num(v.name); if (v.price > 0 && n > 0 && (!base || n < base.n)) base = { n: n, per: v.price / n }; });
    var anyPrice = vals.some(function (v) { return v.price > 0; });
    var html = '<div class="pp-tiers__head"><span class="pp-label">' + esc(q.name) + '</span>' + (anyPrice ? '<span class="pp-tiers__cols" aria-hidden="true"><span>Total</span><span>Per ' + esc(unitWord(vals[0].name)) + '</span></span>' : '') + '</div>';
    html += '<div class="pp-tiers__list' + (anyPrice ? '' : ' pp-tiers__list--grid') + '" role="radiogroup" aria-label="' + esc(q.name) + '">';
    var checked = $('input[type="radio"]:checked', native);
    vals.forEach(function (v) {
      var n = num(v.name), on = checked ? checked.value === v.name : v.on, priced = v.price > 0, per = priced && n > 0 ? v.price / n : 0;
      var save = (priced && base && n > base.n) ? Math.floor((1 - per / base.per) * 100) : 0;
      html += '<button type="button" role="radio" class="pp-tier' + (on ? ' is-on' : '') + (priced ? '' : ' is-req') + '" aria-checked="' + on + '" data-v="' + esc(v.name) + '">' +
        '<span class="pp-tier__q"><i aria-hidden="true"></i>' + esc(v.name) + (save >= 1 ? '<em>Save ' + save + '%</em>' : '') + '</span>' +
        (anyPrice ? '<span class="pp-tier__t">' + (priced ? moneyShort(v.price) : 'On request') + '</span><span class="pp-tier__u">' + (priced && n > 1 ? moneyShort(Math.round(per)) : (priced ? '–' : '')) + '</span>' : '') +
        '</button>';
    });
    html += '</div>';
    if (anyPrice && base) html += '<p class="pp-tiers__note">Savings are compared with the price per ' + esc(unitWord(vals[0].name)) + ' of the smallest pack.</p>';
    host.innerHTML = html;
    $$('.pp-tier', host).forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.getAttribute('data-v');
        var input = $$('input[type="radio"]', native).filter(function (i) { return i.value === val; })[0];
        if (!input || input.checked) return;
        input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true }));
        $$('.pp-tier', host).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b); });
        track('pp_qty_select', { quantity: val });
      });
      b.addEventListener('keydown', function (e) {
        if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) < 0) return;
        e.preventDefault(); var all = $$('.pp-tier', host), i = all.indexOf(b);
        var n = all[(i + (/Down|Right/.test(e.key) ? 1 : all.length - 1)) % all.length]; n.focus(); n.click();
      });
    });
    var onBtn = $('.pp-tier.is-on', host); $$('.pp-tier', host).forEach(function (b) { b.tabIndex = b === onBtn ? 0 : -1; });
  }

  /* ---------- option explanations ---------- */
  var GLOSS = [
    [/express/i, 'Express: ready in 24 hours. Order and pay (and approve any proof) by 14:00 Bangkok time. Sundays are not counted.'],
    [/standard \(72/i, 'Standard: ready in 72 hours from confirmed payment, or from proof approval if you add a proof. Sundays are not counted.'],
    [/backlit/i, 'Backlit film: made for light boxes, so the image glows evenly when lit from behind.'],
    [/holographic/i, 'Holographic: a rainbow, mirror-like effect that shifts as the light moves.'],
    [/destructible/i, 'Destructible vinyl: breaks into small pieces if someone tries to peel it off.'],
    [/void/i, 'VOID film: leaves a “VOID” pattern behind if the label is peeled off.'],
    [/raised/i, 'Raised: a layer that stands up from the surface, so you can feel it as well as see it.'],
    [/^(?!no ).*foil/i, 'Foil: a thin metallic layer that catches the light.'],
    [/soft.?touch/i, 'Soft touch: a velvety, matte surface you can feel.'],
    [/blockout/i, 'Blockout vinyl: has an opaque core, so light and the other side don’t show through.'],
    [/mesh/i, 'Mesh vinyl: perforated so wind passes through. Good for fences, railings and windy spots.'],
    [/one-way|perforated\)/i, 'One-way vision: perforated film. The print shows outside while you can still see out from inside.'],
    [/static cling/i, 'Static cling: sticks to glass without glue, so it can be removed and reused.'],
    [/bopp/i, 'BOPP: a polypropylene label film that resists water and oil. Good for bottles, jars and fridges.'],
    [/clear/i, 'Clear: transparent material. Areas without ink stay see-through.'],
    [/frosted/i, 'Frosted: translucent with a matte, etched-glass look.'],
    [/synthetic|waterproof/i, 'Synthetic: a plastic-based sheet that resists water and tearing.'],
    [/laminat/i, 'Lamination: a thin film on top of the print that protects it from wear and moisture.'],
    [/linen/i, 'Linen: textured paper with a fine woven pattern, like linen fabric.'],
    [/kraft/i, 'Kraft: natural brown paper with an organic, unbleached look.'],
    [/pearl/i, 'Pearl: paper with a subtle shimmer.'],
    [/cotton/i, 'Cotton: thick, soft paper made with cotton fibre.'],
    [/textured/i, 'Natural textured: uncoated paper with a visible, tactile texture.'],
    [/satin/i, 'Satin: between gloss and matte, with a soft sheen.'],
    [/uncoated/i, 'Uncoated: natural paper without a coating. Non-reflective and easy to write on.'],
    [/matte/i, 'Matte: a smooth, low-shine finish that reduces glare.'],
    [/gloss/i, 'Gloss: a smooth, shiny finish that makes colours look bright.'],
    [/white vinyl/i, 'White vinyl: a durable, water-resistant sticker material.'],
    [/white paper/i, 'Paper: an economical label material for dry, indoor use.'],
    [/rounded/i, 'Rounded corners: the corners are cut round for a softer look; tips don’t bend as easily.'],
    [/lay-flat/i, 'Lay-flat: pages open completely flat, so photos can run across both pages.'],
    [/tri-fold/i, 'Tri-fold: folded twice into three panels, like a letter.'],
    [/z-fold/i, 'Z-fold: folded twice in a zig-zag, opening like an accordion.'],
    [/bi-fold/i, 'Bi-fold: folded once in the middle, giving four panels.'],
    [/kiss-cut|die-cut/i, 'Die-cut: cut to the exact outline of the shape.']
  ];
  var GSM = 'gsm is paper weight: the higher the number, the thicker and stiffer the paper.';
  function explain(comp, val) {
    if (/sides|printing|quantity|size|shape|pages|envelope|string|stake|bundle|stand|height|layout|service|package/i.test(comp) && !/turnaround/i.test(comp)) return '';
    for (var i = 0; i < GLOSS.length; i++) if (GLOSS[i][0].test(val)) return GLOSS[i][1] + (/\bgsm\b/i.test(val) && /paper|thickness|cover/i.test(comp) ? ' ' + GSM : '');
    if (/\bgsm\b/i.test(val)) return GSM;
    return '';
  }
  function paintExplain() {
    var host = $('.pp-compound', root); if (!host) return;
    var parts = selectionParts(current);
    $$('.pp-comp', host).forEach(function (el) {
      var i = +el.getAttribute('data-i'); var p = parts[i]; if (!p) return;
      var t = explain(p.name, p.value);
      var n = el.querySelector('.pp-explain');
      if (!t) { if (n) n.remove(); return; }
      if (!n) { n = document.createElement('p'); n.className = 'pp-explain'; el.appendChild(n); }
      if (n.textContent !== t) n.textContent = t;
    });
  }
  // The theme re-renders the variant picker on every change: repaint our parts straight away (no flash of the native list)
  var vpBlock = $('.product__block--variant_picker', root);
  if (vpBlock && 'MutationObserver' in window) new MutationObserver(function () {
    if (!document.getElementById('pp-tiers-' + SID)) paintTiers();
    paintExplainFromDom();
  }).observe(vpBlock, { childList: true, subtree: true });
  function paintExplainFromDom() { // pp-compound re-rendered: explain the values it shows as selected
    var host = $('.pp-compound', root); if (!host) return;
    $$('.pp-comp', host).forEach(function (el) {
      var name = (el.querySelector('.font-body-bolder') || {}).textContent || ''; name = name.replace(/:\s*$/, '');
      var val = (el.querySelector('.text-subtext') || {}).textContent || '';
      var t = explain(name, val);
      var n = el.querySelector('.pp-explain');
      if (!t) { if (n) n.remove(); return; }
      if (!n) { n = document.createElement('p'); n.className = 'pp-explain'; el.appendChild(n); }
      if (n.textContent !== t) n.textContent = t;
    });
  }

  /* ---------- size & shape guide ---------- */
  var SIZE_RE = /(Ø\s*)?(\d+(?:\.\d+)?)\s*(?:[×x]\s*(\d+(?:\.\d+)?))?\s*(mm|cm|m)\b/i;
  function parseSize(parts) {
    var sz = null, shape = '', upto = false, sides = 1;
    parts.forEach(function (p) {
      if (/^(size|sheet size|shape|height|dimensions?)$/i.test(p.name) || (!sz && SIZE_RE.test(p.value) && /size|shape/i.test(p.name))) {
        var m = p.value.match(SIZE_RE);
        if (m && !sz) {
          var f = m[4].toLowerCase() === 'mm' ? 0.1 : (m[4].toLowerCase() === 'm' ? 100 : 1);
          sz = { w: parseFloat(m[2]) * f, h: (m[3] ? parseFloat(m[3]) : parseFloat(m[2])) * f, d: !!m[1], unit: m[4], raw: p.value, label: m[0].replace(/\s+/g, ' ') };
          if (/height/i.test(p.name) && !m[3]) { sz.w = sz.h * 0.28; sz.flag = true; }
        }
        if (/up to/i.test(p.value)) upto = true;
      }
      if (/shape/i.test(p.name) || /size/i.test(p.name)) {
        var v = p.value.toLowerCase();
        if (/half arch \(left\)|half arch/.test(v)) shape = /right/.test(v) ? 'halfR' : 'halfL';
        else if (/arch/.test(v)) shape = 'arch';
        else if (/circle|Ø/.test(v)) shape = shape || 'circle';
        else if (/oval/.test(v)) shape = 'oval';
        else if (/leaf/.test(v)) shape = 'leaf';
        else if (/teardrop/.test(v)) shape = 'tear';
        else if (/feather/.test(v)) shape = 'feather';
        else if (/rounded/.test(v)) shape = shape || 'round';
      }
      if (/sides|printing/i.test(p.name) && /back|double/i.test(p.value)) sides = 2;
    });
    if (sz && sz.d) shape = 'circle';
    if (sz && sz.raw && /\(landscape\)|landscape/i.test(sz.raw) && sz.h > sz.w) { var t = sz.w; sz.w = sz.h; sz.h = t; }
    return sz ? { sz: sz, shape: shape || 'rect', upto: upto, sides: sides } : null;
  }
  function shapePath(shape, x, y, w, h) {
    switch (shape) {
      case 'circle': return '<ellipse cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" rx="' + w / 2 + '" ry="' + h / 2 + '"/>';
      case 'oval': return '<ellipse cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" rx="' + w / 2 + '" ry="' + h / 2 + '"/>';
      case 'leaf': return '<path d="M' + x + ' ' + (y + h / 2) + 'Q' + (x + w * 0.35) + ' ' + (y - h * 0.15) + ' ' + (x + w) + ' ' + (y + h * 0.08) + 'Q' + (x + w * 0.72) + ' ' + (y + h * 1.12) + ' ' + x + ' ' + (y + h / 2) + 'Z"/>';
      case 'arch': return '<path d="M' + x + ' ' + (y + h) + 'V' + (y + w / 2) + 'A' + w / 2 + ' ' + w / 2 + ' 0 0 1 ' + (x + w) + ' ' + (y + w / 2) + 'V' + (y + h) + 'Z"/>';
      case 'halfL': return '<path d="M' + x + ' ' + (y + h) + 'V' + (y + w) + 'A' + w + ' ' + w + ' 0 0 1 ' + (x + w) + ' ' + y + 'V' + (y + h) + 'Z"/>';
      case 'halfR': return '<path d="M' + (x + w) + ' ' + (y + h) + 'V' + (y + w) + 'A' + w + ' ' + w + ' 0 0 0 ' + x + ' ' + y + 'V' + (y + h) + 'Z"/>';
      case 'round': return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + Math.min(w, h) * 0.12 + '"/>';
      case 'tear': return '<path d="M' + (x + w * 0.15) + ' ' + (y + h) + 'V' + (y + h * 0.35) + 'Q' + (x + w * 0.2) + ' ' + y + ' ' + (x + w * 0.85) + ' ' + y + 'Q' + (x + w) + ' ' + (y + h * 0.55) + ' ' + (x + w * 0.15) + ' ' + (y + h * 0.75) + '"/>';
      case 'feather': return '<path d="M' + (x + w * 0.15) + ' ' + (y + h) + 'V' + y + 'Q' + (x + w) + ' ' + (y + h * 0.05) + ' ' + (x + w * 0.85) + ' ' + (y + h * 0.75) + 'L' + (x + w * 0.15) + ' ' + (y + h * 0.8) + '"/>';
      default: return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + Math.min(w, h) * 0.02 + '"/>';
    }
  }
  function paintSize() {
    var box = $('[data-pp-size]', root); if (!box) return;
    var info = parseSize(selectionParts(current));
    if (!info) { box.hidden = true; return; }
    var s = info.sz, maxd = Math.max(s.w, s.h);
    var ref = maxd <= 22 ? { w: 8.56, h: 5.4, t: 'Bank card', a: 'a bank card', r: 0.35 } : (maxd <= 60 ? { w: 21, h: 29.7, t: 'A4 sheet', a: 'an A4 sheet', r: 0.2 } : { w: 45, h: 170, t: '1.7 m person', a: 'a 1.7 m tall person', p: true });
    var W = 300, H = 150, pad = 16, gap = 22;
    var copies = info.sides;
    var totalW = s.w * copies + (copies - 1) * (s.w * 0.18) + ref.w, maxH = Math.max(s.h, ref.h);
    var k = Math.min((W - pad * 2 - gap) / totalW, (H - pad * 2 - 18) / maxH);
    var y0 = pad + 4, svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" role="img">';
    var x = pad, sw = s.w * k, sh = s.h * k;
    for (var c = 0; c < copies; c++) {
      var yy = y0 + (maxH * k - sh);
      svg += '<g class="pp-sz__obj' + (c ? ' is-back' : '') + '">' + shapePath(info.shape, x, yy, sw, sh) + '</g>';
      if (copies > 1) svg += '<text x="' + (x + sw / 2) + '" y="' + (yy + sh / 2 + 4) + '" class="pp-sz__in">' + (c ? 'Back' : 'Front') + '</text>';
      if (c === 0) {
        svg += '<line class="pp-sz__dim" x1="' + x + '" x2="' + (x + sw) + '" y1="' + (yy + sh + 9) + '" y2="' + (yy + sh + 9) + '"/>';
      }
      x += sw + s.w * 0.18 * k;
    }
    x += gap - s.w * 0.18 * k;
    var rw = ref.w * k, rh = ref.h * k, ry = y0 + (maxH * k - rh);
    if (ref.p) {
      svg += '<g class="pp-sz__ref"><circle cx="' + (x + rw / 2) + '" cy="' + (ry + rw * 0.28) + '" r="' + rw * 0.26 + '"/><rect x="' + (x + rw * 0.12) + '" y="' + (ry + rw * 0.6) + '" width="' + rw * 0.76 + '" height="' + (rh - rw * 0.6) + '" rx="' + rw * 0.3 + '"/></g>';
    } else {
      svg += '<g class="pp-sz__ref">' + '<rect x="' + x + '" y="' + ry + '" width="' + rw + '" height="' + rh + '" rx="' + Math.min(rw, rh) * ref.r * 0.2 + '"/></g>';
    }
    svg += '<text x="' + (x + rw / 2) + '" y="' + (H - 4) + '" class="pp-sz__lbl">' + ref.t + '</text>';
    svg += '</svg>';
    $('[data-pp-size-fig]', box).innerHTML = svg;
    var dims = s.flag ? fmtLen(s.h) + ' tall' : s.label.replace(/^Ø\s*/, 'Ø ').replace(/\s*[×x]\s*/, ' × ');
    $('[data-pp-size-val]', box).textContent = (info.upto ? 'Up to ' : '') + dims + (copies > 1 ? ' · printed on both sides' : '');
    $('[data-pp-size-note]', box).textContent = info.upto ? 'Maximum size: each piece is cut to your design within this area.' : 'Drawn to scale next to ' + ref.a + '. Quantity doesn’t change the size.';
    box.hidden = false;
  }
  function fmtLen(cm) { return cm >= 100 ? (Math.round(cm) / 100).toString().replace(/\.?0+$/, '') + ' m' : (Math.round(cm * 10) / 10).toString() + ' cm'; }

  /* ---------- gallery caption for option images ---------- */
  var cap = null;
  function caption(text, missing) {
    var g = $('media-gallery', root); if (!g) return;
    var wrap = $('.product__media-gallery-viewer-wrap', g) || g;
    if (!cap) { cap = document.createElement('p'); cap.className = 'pp-gcap'; cap.setAttribute('aria-live', 'polite'); wrap.appendChild(cap); }
    cap.textContent = text; cap.classList.toggle('is-missing', !!missing); cap.hidden = !text;
  }
  function wrapCompound(PC) {
    if (!PC || PC.prototype.__ppWrapped) return;
    var orig = PC.prototype.showImage;
    PC.prototype.showImage = function (comp, val) {
      var map = this.images && this.images[comp];
      orig.call(this, comp, val);
      if (map && map[val]) caption('Shown: ' + val);
      else if (map) caption('No photo of “' + val + '” yet. The image shows another option.', true);
      else caption('');
      track('pp_option_select', { component: comp, value: val });
    };
    PC.prototype.__ppWrapped = true;
  }
  if (window.customElements) customElements.whenDefined('pp-compound').then(function () { wrapCompound(customElements.get('pp-compound')); });
  root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.product__media-gallery .swiper-button-next, .product__media-gallery .swiper-button-prev, .product__media-gallery [class*="thumb"]')) caption(''); });

  /* ---------- artwork step (OPTIS + Uploadly + link + notes) ---------- */
  function bssExtra(optionId) {
    try {
      var seen = new WeakSet(), hit = null;
      (function walk(o, depth) {
        if (hit || !o || typeof o !== 'object' || depth > 8 || seen.has(o) || o instanceof Node) return; seen.add(o);
        if (o.id === optionId && o.extra_price) { hit = o.extra_price; return; }
        for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) walk(o[k], depth + 1); }
      })(window.BSS_PO && BSS_PO.optionSets, 0);
      return hit;
    } catch (e) { return null; }
  }
  var ART_TXT = {
    "i'll upload my print-ready files": ['Upload a print-ready file or paste a link. We print it exactly as uploaded.', 'upload'],
    'fix my artwork (text, logo, resize)': ['You have a file that needs small changes: text, logo or size. Upload it and tell us what to change.', 'fix'],
    'design it for me': ['No artwork yet. Our designers create it from your brief, and you approve a proof before we print.', 'design']
  };
  function setupArtwork() {
    if (D.type === 'Design Services') return true;
    var app = $('.product__block--\\@app', root) || $('.bss-po-option-set', root);
    var radios = $$('input[type="radio"][key="po_Your artwork"]', root);
    if (!radios.length) return false;
    var stack = radios[0].closest('.po-stack');
    if (stack.__pp) return true; stack.__pp = true;
    stack.classList.add('pp-art');
    var optId = +(String(radios[0].getAttribute('onchange') || '').match(/optionIdForCheckBoxOnly:\s*(\d+)/) || [])[1];
    var ex = optId ? bssExtra(optId) : null;
    var prices = ex && ex.radio_button_extra_price ? ex.radio_button_extra_price : [];
    radios.forEach(function (r, i) {
      var lab = r.closest('label'); if (!lab) return;
      var key = String(r.value).trim().toLowerCase(), t = ART_TXT[key];
      var desc = lab.querySelector('.po_description');
      if (t && desc && !desc.querySelector('.pp-art__d')) {
        var p = document.createElement('span'); p.className = 'pp-art__d'; p.textContent = t[0]; desc.appendChild(p);
        lab.setAttribute('data-pp-art', t[1]);
      }
      var amt = parseFloat(prices[i]);
      var val = desc && desc.querySelector('.po_option_value');
      if (desc && val && !desc.querySelector('.pp-art__p')) {
        var chip = document.createElement('span');
        chip.className = 'pp-art__p' + (amt > 0 ? '' : ' pp-art__p--inc');
        chip.textContent = amt > 0 ? '+' + moneyShort(Math.round(amt * 100)) : 'Included';
        val.parentNode.insertBefore(chip, val.nextSibling);
      }
    });
    // proof checkbox: show its price, move it after the upload fields
    var proof = $$('.po-stack', root).filter(function (s) { return /proof/i.test(s.textContent || '') && s.querySelector('input[type="checkbox"]'); })[0];
    var proofPrice = '';
    if (proof) {
      proof.classList.add('pp-proof');
      var cb = proof.querySelector('input[type="checkbox"]');
      var pid = +(String(cb.getAttribute('onchange') || '').match(/optionIdForCheckBoxOnly:\s*(\d+)/) || String(proof.id).match(/(\d+)$/) || [])[1];
      var pex = pid ? bssExtra(pid) : null, pp = pex && pex.checkbox_extra_price ? parseFloat(pex.checkbox_extra_price[0]) : 0;
      if (pp > 0) { proofPrice = moneyShort(Math.round(pp * 100)); var tag = document.createElement('span'); tag.className = 'pp-art__p'; tag.textContent = '+' + proofPrice; var l = proof.querySelector('.po-label-container') || proof; l.appendChild(tag); }
      var hint = document.createElement('p'); hint.className = 'pp-proof__h'; hint.textContent = 'We send you a digital proof to approve. Production starts once you approve it.'; proof.appendChild(hint);
    }
    $$('[data-pp-proof-price]').forEach(function (e) { e.textContent = proofPrice ? ' (' + proofPrice + ')' : ''; });
    // upload area: Uploadly widget + link + notes, grouped in one panel under the choices
    var panel = document.getElementById('pp-art-panel-' + SID);
    if (!panel) {
      panel = document.createElement('div'); panel.id = 'pp-art-panel-' + SID; panel.className = 'pp-artpanel';
      var appBlock = app && app.closest ? (app.closest('.product__block') || app) : app;
      appBlock.parentNode.insertBefore(panel, appBlock.nextSibling);
    }
    var up = document.getElementById('photouploadapp');
    function fitUpload() {
      $$('#photouploadapp [style*="width"]').forEach(function (e) { if (/\d{3}px/.test(e.style.width)) e.style.setProperty('width', '100%', 'important'); });
      // the app label promises "up to 500MB": not confirmed for our Uploadly plan, so the page doesn't repeat it
      $$('#photouploadapp p[data-ph-product-id]').forEach(function (p) { if (/500\s*MB/i.test(p.textContent)) p.textContent = 'Upload your artwork (PDF, AI, PNG or JPG)'; });
    }
    fitUpload(); setTimeout(fitUpload, 1500); if (up && 'MutationObserver' in window) new MutationObserver(fitUpload).observe(up, { childList: true, subtree: true });
    var linkBlock = $('.pp-artwork-link', root), notes = $('.pp-notes', root);
    if (up && up.parentNode !== panel) panel.appendChild(up);
    if (linkBlock && linkBlock.parentNode !== panel) panel.appendChild(linkBlock);
    if (notes && notes.parentNode !== panel) panel.appendChild(notes);
    if (proof && proof.parentNode !== panel) panel.appendChild(proof);
    var apparel = $('.pp-apparel', root); if (apparel && apparel.parentNode !== panel) panel.insertBefore(apparel, panel.firstChild);
    function sync(ev) {
      var r = radios.filter(function (x) { return x.checked; })[0];
      var mode = r ? (ART_TXT[String(r.value).trim().toLowerCase()] || [0, 'upload'])[1] : 'upload';
      root.setAttribute('data-pp-art-mode', mode);
      radios.forEach(function (x) { var lab = x.closest('.po-option--radioButton-wrapper'); if (lab) lab.classList.toggle('is-on', x.checked); });
      var nl = notes && notes.querySelector('label'), nt = notes && notes.querySelector('textarea');
      if (nl && nt) {
        if (mode === 'fix') { nl.textContent = 'What should we change?'; nt.placeholder = 'e.g. update the phone number, add our new logo, resize to this product'; }
        else { nl.textContent = 'Notes for our team (optional)'; nt.placeholder = 'Anything we should know about your order'; }
      }
      // design orders always include a proof: never leave the paid proof ticked (hidden) in design mode
      if (mode === 'design' && proof) { var pc = proof.querySelector('input[type="checkbox"]'); if (pc && pc.checked) { pc.checked = false; pc.dispatchEvent(new Event('change', { bubbles: true })); } }
      if (ev) track('pp_artwork_choice', { choice: mode });
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
    return true;
  }
  function tryArtwork(n) { if (!setupArtwork() && n < 40) setTimeout(function () { tryArtwork(n + 1); }, 250); }
  // Uploadly: report finished uploads (once per file value)
  var lastArt = '';
  setInterval(function () {
    var v = $$('input[name^="properties[Artwork"]').map(function (i) { return i.name === 'properties[Artwork link]' ? '' : (i.value || ''); }).join('|');
    if (v && v !== lastArt && /\S/.test(v.replace(/\|/g, ''))) { lastArt = v; track('pp_artwork_uploaded', {}); }
  }, 1500);

  /* ---------- no ฿0 sales ---------- */
  function blocked(ids) {
    if (QA) return false;
    for (var i = 0; i < ids.length; i++) { var p = priceById[ids[i]]; if (p === 0 || p === null) return true; }
    return false;
  }
  function showPending() {
    var pen = $('[data-pp-pending]', root);
    if (pen) { pen.hidden = false; pen.classList.remove('is-flash'); void pen.offsetWidth; pen.classList.add('is-flash'); pen.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#' + FORM_ID + ' [name="add"], [form="' + FORM_ID + '"][name="add"], .pp-sticky [data-pp-sticky-add], .po-atc-btn');
    if (!b) return;
    if (isPending(current) && !QA) { e.preventDefault(); e.stopImmediatePropagation(); showPending(); track('pp_add_blocked_unpriced', {}); }
  }, true);
  var of = window.fetch;
  window.fetch = function (u, o) {
    try {
      var s = typeof u === 'string' ? u : (u && u.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(s) && o && o.body) {
        var ids = [];
        if (typeof o.body === 'string') { try { var j = JSON.parse(o.body); (j.items || [j]).forEach(function (it) { if (it.id) ids.push(+it.id); }); } catch (x) {} }
        else if (o.body instanceof FormData) { var id = o.body.get('id'); if (id) ids.push(+id); }
        if (blocked(ids)) { showPending(); return Promise.reject(new Error('This option has no online price yet. Please request a quote.')); }
        var p = of.apply(this, arguments);
        p.then(function (r) { if (r && r.ok) track('pp_add_to_cart', { variant_ids: ids, source: (typeof o.body === 'string' && /_pp_own/.test(o.body)) ? 'fbt' : 'main' }); }).catch(function () {});
        return p;
      }
    } catch (x) {}
    return of.apply(this, arguments);
  };

  /* ---------- sticky mobile purchase bar ---------- */
  var sticky = document.createElement('div');
  sticky.className = 'pp-sticky'; sticky.hidden = true; sticky.setAttribute('aria-label', 'Quick purchase');
  sticky.innerHTML = '<div class="pp-sticky__i"><p class="pp-sticky__t"></p><p class="pp-sticky__p"></p></div><a class="pp-btn pp-btn--ink pp-sticky__q" data-pp-quote data-pp-cta="pdp_sticky_quote" href="#">Get a price</a><button type="button" class="pp-btn pp-btn--ink pp-sticky__a" data-pp-sticky-add>Add to cart</button>';
  document.body.appendChild(sticky);
  var mainBtnVisible = true, stepSeen = false, kbd = false;
  function paintSticky() {
    var d = current, parts = selectionParts(d).filter(function (p) { return !/quantity/i.test(p.name); }).map(function (p) { return p.value; });
    var q = qtyOption(d);
    $('.pp-sticky__t', sticky).textContent = (q ? q.selected + ' · ' : '') + parts.slice(0, 3).join(' · ');
    $('.pp-sticky__p', sticky).textContent = isPending(d) ? 'Price on request' : money(d.variant.price);
    sticky.classList.toggle('is-pending', isPending(d));
    var show = !QUOTE_ONLY && window.matchMedia('(max-width: 989px)').matches && stepSeen && !mainBtnVisible && !kbd;
    sticky.hidden = !show; document.documentElement.classList.toggle('pp-sticky-on', show);
  }
  $('.pp-sticky__a', sticky).addEventListener('click', function () {
    var b = document.querySelector('#' + FORM_ID + ' [name="add"]') || document.querySelector('[form="' + FORM_ID + '"][name="add"]');
    if (!b) return;
    b.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () { b.click(); }, reduce ? 0 : 380);
  });
  // Visibility by measurement on scroll (IntersectionObserver misses jumps past an element)
  function onScreen(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight; }
  function measureSticky() {
    var s1 = document.getElementById('pp-step-1');
    stepSeen = s1 ? s1.getBoundingClientRect().top < window.innerHeight * 0.6 : true;
    var target = isPending(current) ? $('[data-pp-pending]', root) : (document.querySelector('#' + FORM_ID + ' [name="add"]') || document.querySelector('[form="' + FORM_ID + '"][name="add"]'));
    mainBtnVisible = onScreen(target);
    paintSticky();
  }
  var tick = false;
  window.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; measureSticky(); }); }, { passive: true });
  measureSticky();
  document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input:not([type=radio]):not([type=checkbox]),textarea,select')) { kbd = true; paintSticky(); } });
  document.addEventListener('focusout', function () { setTimeout(function () { var a = document.activeElement; kbd = !!(a && a.matches && a.matches('input:not([type=radio]):not([type=checkbox]),textarea,select')); paintSticky(); }, 60); });
  window.addEventListener('resize', measureSticky, { passive: true });

  /* ---------- share ---------- */
  var dlg = $('[data-pp-share-dlg]'), lastFocus = null;
  function closeShare() { if (!dlg || dlg.hidden) return; dlg.hidden = true; document.documentElement.classList.remove('pp-share-open'); if (lastFocus) lastFocus.focus(); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pp-share]');
    if (b) {
      e.preventDefault();
      var url = (dlg && $('[data-pp-share-url]', dlg).value) || location.href.split('?')[0];
      if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
        navigator.share({ title: D.title, url: url }).then(function () { track('pp_share', { network: 'native' }); }).catch(function () {});
        return;
      }
      if (!dlg) return; lastFocus = b; dlg.hidden = false; document.documentElement.classList.add('pp-share-open');
      var f = $('a,button', dlg); if (f) f.focus();
      return;
    }
    if (!dlg || dlg.hidden) return;
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-pp-share-close]'))) closeShare();
    var net = e.target.closest && e.target.closest('[data-pp-net]'); if (net) track('pp_share', { network: net.getAttribute('data-pp-net') });
  });
  document.addEventListener('keydown', function (e) {
    if (!dlg || dlg.hidden) return;
    if (e.key === 'Escape') closeShare();
    if (e.key === 'Tab') { var f = $$('a,button,input', dlg), a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
  });
  if (dlg) {
    var cp = $('[data-pp-copy]', dlg);
    if (cp) cp.addEventListener('click', function () {
      var i = $('[data-pp-share-url]', dlg), v = i.value;
      var ok = function () { cp.textContent = 'Copied'; setTimeout(function () { cp.textContent = 'Copy link'; }, 2000); track('pp_share', { network: 'copy' }); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(ok, function () { i.select(); try { document.execCommand('copy'); ok(); } catch (x) {} });
      else { i.select(); try { document.execCommand('copy'); ok(); } catch (x) {} }
    });
  }

  /* ---------- Frequently bought together ---------- */
  var fbt = $('[data-pp-fbt]');
  var fbtState = {};               // handle -> {data, comps, cur:[...], qtyId, art:'same|link|later', link:''}
  function fbtMain() {
    var el = $('[data-pp-fbt-mainsel]'); if (!el) return;
    var parts = selectionParts(current).map(function (p) { return p.value; });
    el.textContent = parts.join(' · ');
  }
  function allowedVals(st, i, prefix) {
    var out = [];
    st.values.forEach(function (v) { for (var k = 0; k < i; k++) if (v[k] !== prefix[k]) return; if (out.indexOf(v[i]) < 0) out.push(v[i]); });
    return out;
  }
  function fbtBuild(li, d) {
    var h = li.getAttribute('data-handle'), st = fbtState[h] = fbtState[h] || {};
    st.data = d;
    var o0 = d.options[0], names = compNames(d), q = qtyOption(d);
    st.names = names || (q ? [o0.name] : d.options.map(function (o) { return o.name; }));
    st.values = (q || d.options.length === 1) ? o0.values.map(function (v) { return names ? v.name.split(SEP) : [v.name]; }) : [];
    st.cur = names ? String(o0.selected).split(SEP) : [o0.selected];
    st.art = st.art || 'same';
    fbtRender(li);
  }
  function fbtVariant(st) { return st.data.variant; }
  function fbtRender(li) {
    var h = li.getAttribute('data-handle'), st = fbtState[h], d = st.data, q = qtyOption(d), cfg = $('[data-pp-fbt-cfg]', li);
    var html = '<div class="pp-mini">';
    st.names.forEach(function (n, i) {
      var opts = allowedVals(st, i, st.cur);
      if (opts.length < 2 && !q) return;
      if (opts.length < 2) { html += '<p class="pp-mini__fixed"><span>' + esc(n) + '</span>' + esc(st.cur[i]) + '</p>'; return; }
      html += '<label class="pp-mini__f"><span>' + esc(n) + '</span><select data-i="' + i + '">' + opts.map(function (v) { return '<option' + (v === st.cur[i] ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') + '</select></label>';
    });
    if (q) html += '<label class="pp-mini__f"><span>' + esc(q.name) + '</span><select data-q>' + q.values.map(function (v) { return '<option value="' + v.id + '"' + (v.on ? ' selected' : '') + '>' + esc(v.name) + (v.price > 0 ? ' – ' + moneyShort(v.price) : '') + '</option>'; }).join('') + '</select></label>';
    var mainT = esc(D.title);
    html += '<fieldset class="pp-mini__art"><legend>Artwork for this item</legend>' +
      '<label><input type="radio" name="pp-art-' + esc(h) + '" value="same"' + (st.art === 'same' ? ' checked' : '') + '> Use the artwork from my ' + mainT + ' order</label>' +
      '<label><input type="radio" name="pp-art-' + esc(h) + '" value="link"' + (st.art === 'link' ? ' checked' : '') + '> Paste a link to the file</label>' +
      (st.art === 'link' ? '<input type="url" class="pp-mini__link" placeholder="https://" value="' + esc(st.link || '') + '" aria-label="Link to the artwork for ' + esc(d.title) + '">' : '') +
      '<label><input type="radio" name="pp-art-' + esc(h) + '" value="later"' + (st.art === 'later' ? ' checked' : '') + '> I’ll send it after ordering</label>' +
      '<p class="pp-mini__hint">' + (st.art === 'later' ? 'Production starts once we have your file. Reply to your order email or message us on WhatsApp or LINE.' : (st.art === 'same' ? 'We print the same file on this item. If it doesn’t fit this format, we contact you before printing.' : 'Canva, Google Drive or Dropbox links work.')) + '</p></fieldset>';
    html += '</div>';
    cfg.innerHTML = html;
    var pe = $('[data-pp-fbt-price]', li), v = fbtVariant(st);
    pe.textContent = v.price > 0 ? money(v.price) : 'Price on request';
    li.classList.toggle('is-req', !(v.price > 0));
    $$('select[data-i]', cfg).forEach(function (s) {
      s.addEventListener('change', function () {
        var i = +s.getAttribute('data-i'); var nxt = st.cur.slice(0, i); nxt[i] = s.value;
        for (var k = i + 1; k < st.names.length; k++) { var ok = allowedVals(st, k, nxt); nxt[k] = ok.indexOf(st.cur[k]) > -1 ? st.cur[k] : ok[0]; }
        st.cur = nxt; fbtReload(li);
      });
    });
    var qs = $('select[data-q]', cfg); if (qs) qs.addEventListener('change', function () { fbtReload(li, +qs.value); });
    $$('input[type=radio]', cfg).forEach(function (r) { r.addEventListener('change', function () { st.art = r.value; fbtRender(li); var l = $('.pp-mini__link', cfg); if (l) l.focus(); }); });
    var lk = $('.pp-mini__link', cfg); if (lk) lk.addEventListener('input', function () { st.link = lk.value.trim(); fbtSum(); });
    fbtSum();
  }
  function fbtReload(li, qtyValueId) {
    var h = li.getAttribute('data-handle'), st = fbtState[h], d = st.data, o0 = d.options[0], q = qtyOption(d);
    var name0 = st.cur.join(SEP), v0 = o0.values.filter(function (v) { return v.name === name0; })[0];
    if (!v0) return;
    var qv = q ? (qtyValueId || (q.values.filter(function (v) { return v.on; })[0] || q.values[0]).id) : null;
    li.classList.add('is-loading');
    view(li.getAttribute('data-url'), 'option_values=' + v0.id + (qv ? ',' + qv : '')).then(function (nd) { li.classList.remove('is-loading'); st.data = nd; fbtRender(li); })
      .catch(function () { li.classList.remove('is-loading'); });
  }
  function fbtChecked() { return $$('[data-pp-fbt-item]', fbt).filter(function (li) { return $('[data-pp-fbt-check]', li).checked; }); }
  function fbtSum() {
    if (!fbt) return;
    var sel = fbtChecked(), total = 0, req = 0, ready = 0, missing = 0;
    sel.forEach(function (li) {
      var st = fbtState[li.getAttribute('data-handle')]; if (!st || !st.data) return;
      var v = st.data.variant; if (v.price > 0) { total += v.price; ready++; } else req++;
      if (st.art === 'link' && !/^https?:\/\/\S+\.\S+/.test(st.link || '')) missing++;
    });
    var s = $('[data-pp-fbt-sum]', fbt), btn = $('[data-pp-fbt-add]', fbt);
    var txt = !sel.length ? 'Tick an item to add it.' : (ready ? ready + ' item' + (ready > 1 ? 's' : '') + ' · <strong>' + money(total) + '</strong>' : '') + (req ? (ready ? ' · ' : '') + req + ' on request' : '');
    s.innerHTML = txt;
    btn.disabled = !(ready || (QA && sel.length)) || missing > 0;
    btn.textContent = (ready || QA) && sel.length ? 'Add ' + (QA ? sel.length : ready) + ' item' + (((QA ? sel.length : ready) > 1) ? 's' : '') + ' to cart' : 'Add selected to cart';
    var m = $('[data-pp-fbt-msg]', fbt);
    if (m.__keep && Date.now() - m.__keep < 6000) { /* keep the success message */ }
    else if (missing) m.textContent = 'Paste the artwork link, or choose another artwork option.';
    else if (req && !QA) m.innerHTML = 'Items marked “Price on request” can’t be bought online yet. <a href="' + ($('[data-pp-quote]') || {}).href + '">Ask for one quote</a>.';
    else m.textContent = '';
    var mbn = $('[data-pp-mb-note]', fbt);
    if (mbn && window.ppMultibuy && window.ppMultibuyMessage) { mbn.hidden = false; mbn.innerHTML = window.ppMultibuyMessage(1 + sel.length).html; } else if (mbn) mbn.hidden = true;
  }
  if (fbt) {
    fbtMain();
    $$('[data-pp-fbt-item]', fbt).forEach(function (li) {
      var cb = $('[data-pp-fbt-check]', li);
      cb.addEventListener('change', function () {
        li.classList.toggle('is-on', cb.checked);
        var cfg = $('[data-pp-fbt-cfg]', li); cfg.hidden = !cb.checked;
        track('pp_fbt_toggle', { item: li.getAttribute('data-handle'), on: cb.checked });
        if (cb.checked && !(fbtState[li.getAttribute('data-handle')] || {}).data) {
          li.classList.add('is-loading'); cfg.innerHTML = '<p class="pp-mini__load">Loading options…</p>';
          view(li.getAttribute('data-url')).then(function (d) { li.classList.remove('is-loading'); fbtBuild(li, d); })
            .catch(function () { li.classList.remove('is-loading'); cfg.innerHTML = '<p class="pp-mini__load">Couldn’t load the options. <a href="' + li.getAttribute('data-url') + '">Open the product</a>.</p>'; });
        } else fbtSum();
      });
    });
    $('[data-pp-fbt-add]', fbt).addEventListener('click', function () {
      var btn = this, items = [], m = $('[data-pp-fbt-msg]', fbt);
      fbtChecked().forEach(function (li) {
        var st = fbtState[li.getAttribute('data-handle')]; if (!st || !st.data) return;
        var v = st.data.variant; if (!(v.price > 0) && !QA) return;
        var props = { _pp_own: '1', _pp_source: 'Bought together with ' + D.title };
        if (st.art === 'same') props['Artwork'] = 'Same file as my ' + D.title + ' order (check fit before printing)';
        else if (st.art === 'link') { props['Artwork'] = 'Link provided'; props['Artwork link'] = st.link; }
        else props['Artwork'] = 'File to follow (do not print until received)';
        items.push({ id: v.id, quantity: 1, properties: props });
      });
      if (!items.length) return;
      btn.disabled = true; m.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
        .then(function () {
          m.__keep = Date.now();
          m.innerHTML = 'Added ' + items.length + ' item' + (items.length > 1 ? 's' : '') + ' to your cart. <a href="/cart">View cart</a>';
          track('pp_fbt_add', { items: items.map(function (i) { return i.id; }), count: items.length });
          updateCartCount();
        })
        .catch(function (err) { m.textContent = err.message || 'Something went wrong. Please try again.'; })
        .finally(function () { btn.disabled = false; fbtSum(); });
    });
  }
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      $$('.cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
      try { if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'pp-fbt', cart: c }); } catch (e) {}
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pp-pk-link],[data-pp-pk-quote],[data-pp-alt]');
    if (a) track(a.hasAttribute('data-pp-alt') ? 'pp_alt_click' : 'pp_package_click', { href: a.getAttribute('href'), package: (a.closest('[data-pp-pk]') || { getAttribute: function () { return ''; } }).getAttribute('data-pp-pk') });
    var c = e.target.closest && e.target.closest('[data-pp-cta]');
    if (c && root.contains(c) || (c && c.closest('[data-pp-extras], .pp-sticky'))) track('pp_cta_click', { cta: c.getAttribute('data-pp-cta'), href: c.getAttribute('href') || '' });
  });

  /* ---------- render ---------- */
  function render() {
    paintPrice(); paintTiers(); paintExplain(); paintSize(); paintSticky(); fbtMain();
  }
  render();
  tryArtwork(0);
  track('pp_product_view', { type: D.type, priced: !isPending(D) });
})();
